export default __webpack_public_path__ + "static/media/payment-turkcell.9491101c.svg";